import { render } from "./EditDashboard.vue?vue&type=template&id=cebb8282&scoped=true"
import script from "./EditDashboard.vue?vue&type=script&lang=js"
export * from "./EditDashboard.vue?vue&type=script&lang=js"

import "./EditDashboard.vue?vue&type=style&index=0&id=cebb8282&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cebb8282"]])

export default __exports__